import { GenericFields } from './genericFields.resource'

export class AdditionalFields {
    fields:GenericFields;
}



